import {
  type Action,
  type ThunkAction,
  configureStore,
} from '@reduxjs/toolkit';
import { citationExtractionListener } from './middleware/citationExtractionListener';
import chatReducer from './slices/chatSlice';
import citationsReducer from './slices/citationsSlice';
import creditsReducer from './slices/creditsSlice';
import documentAnalysisReducer from './slices/documentAnalysisSlice';
import errorModalReducer from './slices/errorModalSlice';
import filterDataReducer from './slices/filters';
import groupPresenceReducer from './slices/groupPresenceSlice';
import historyReducer from './slices/history';
import pricingReducer from './slices/pricingSlice';
import professionalsReducer from './slices/professionalsSlice';
import reactionsReducer from './slices/reactionsSlice';
import researchSessionReducer from './slices/researchSessionSlice';
import searchReducer from './slices/search';
import shareReducer from './slices/shareSlice';
import sidebarLayoutReducer from './slices/sidebarLayoutSlice';
import storageBrowseReducer from './slices/storageBrowseSlice';
import uiSettingsReducer from './slices/uiSettingsSlice';
import usageReducer from './slices/usageSlice';
// import filterSlice from './slices/filterSlice';

export const makeStore = () => {
  return configureStore({
    reducer: {
      filterDataReducer,
      search: searchReducer,
      history: historyReducer,
      researchSession: researchSessionReducer,
      chat: chatReducer,
      uiSettings: uiSettingsReducer,
      sidebarLayout: sidebarLayoutReducer,
      usage: usageReducer,
      citations: citationsReducer,
      errorModal: errorModalReducer,
      share: shareReducer,
      professionals: professionalsReducer,
      documentAnalysis: documentAnalysisReducer,
      storageBrowse: storageBrowseReducer,
      pricing: pricingReducer,
      credits: creditsReducer,
      reactions: reactionsReducer,
      groupPresence: groupPresenceReducer,
      // filterSlice,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().prepend(citationExtractionListener.middleware),
  });
};

// Create a singleton store instance for use outside of components
// This should only be used for preloading data or server-side code
// For client components, continue using the StoreProvider pattern
export const store = makeStore();

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

// Export a reusable type for handwritten thunks
export type AppThunk = ThunkAction<void, RootState, unknown, Action>;
